import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CasiUserStory, CasiUserStoryComment, IProjectFromWeb, User } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiUserStoryCommentService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(id: number): void {
    this.fetch(id).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(id: number): Observable<CasiUserStoryComment[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/userstorycomment/byuserstory/${id}`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => new CasiUserStoryComment(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserStoryCommentsService extends CasiUserStoryCommentService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  get(id: number): Observable<any> {
    this.loading = true;
    return this.apiService.getHttpCall(`userstorycomment/byuserstory/${id}`, 'get')
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => new CasiUserStoryComment(x))),
        tap(() => (this.loading = false)),
        catchError(errRes => {
          return throwError(() => errRes)
        })
      )
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`userstorycomment/byuserstory/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('userstorycomment', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`userstorycomment/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`userstorycomment/${id}`, 'destroy');
  }

  notifyComment(users: User[], userStory: CasiUserStory, comment: any, byUser: string | undefined): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`userstorycomment/notify`, {users, userStory, comment, byUser}, 'notifyOwnersStatus');
  }

}
